import { emailInputValidationSchema } from "../../../../components/AuthForm/components/EmailInput/validation.js";

export const forgotPasswordValidationSchema = emailInputValidationSchema;
